export default function useFixMobileSafariScrollBounce(_a) {
    var isScrollable = _a.isScrollable, isIOS = _a.isIOS, ref = _a.ref;
    if (isIOS) {
        // TODO ideally would only call this hook if isIOS
        return {};
    }
    function onTouchStart() {
        if (isScrollable) {
            if (isScrolledToTop()) {
                hackilyMakeContentStillScrollableAtTop();
            }
            else if (isScrolledToBottom()) {
                hackilyMakeContentStillScrollableAtBottom();
            }
        }
    }
    function onTouchMove(e) {
        if (!isScrollable) {
            e.preventDefault();
        }
    }
    function isScrolledToBottom() {
        // See https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight (Problems and solutions)
        return (ref.current.scrollHeight - ref.current.scrollTop ===
            ref.current.clientHeight);
    }
    function isScrolledToTop() {
        return ref.current.scrollTop === 0;
    }
    function hackilyMakeContentStillScrollableAtTop() {
        // eslint-disable-next-line no-param-reassign
        ref.current.scrollTop = 1;
    }
    function hackilyMakeContentStillScrollableAtBottom() {
        // eslint-disable-next-line no-param-reassign
        ref.current.scrollTop -= 1;
    }
    return { onTouchStart: onTouchStart, onTouchMove: onTouchMove };
}
